// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__3h7ks","wfp--blockquote__icon":"styles_wfp--blockquote__icon__1wqIV","submitWrapper":"styles_submitWrapper__1dFIA"};